import { memo } from "react";
import { useRouteMatch } from "react-router-dom";
import { CartItemSummary, CartLink } from "@monorepo/components";
import { routeConfig } from "@monorepo/constants/routeConfig";
import { useGetCartsQuery } from "@monorepo/services/api/carts";
import theme from "@monorepo/styles/theme";
import { ServiceCategoryIdEnum } from "@monorepo/types";
import { Box } from "@mui/material";
import { reverse } from "named-urls";

interface ICartItemProps {
  cartId: string;
  title: string;
  sum: string;
  delayed: number;
  statusId: number;
}

export const CartItem: React.FC<ICartItemProps> = memo(({ cartId, title, sum, delayed, statusId }) => {
  const { data: carts } = useGetCartsQuery();

  const cart = carts?.find(({ id }) => id === cartId);
  const categoryId = cart?.category_id || ServiceCategoryIdEnum.OTHER;
  const path = reverse(routeConfig.dashboard.payments.cart.cartId, {
    cartId,
  });

  const isActive = !!useRouteMatch({
    path,
  });

  return (
    <CartLink isActive={isActive} to={path} key={cartId}>
      <Box
        sx={{
          position: "relative",
          display: "flex",
          gridColumnGap: theme.spacing(2),
          alignItems: "center",
          overflow: "hidden",
        }}
      >
        <CartItemSummary
          isActive={isActive}
          title={title}
          categoryId={categoryId}
          sum={sum}
          delayed={delayed}
          statusId={statusId}
        />
      </Box>
    </CartLink>
  );
});
